import React from 'react';
import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { updateMetaIntents } from '../../reducer/metaReducer';

import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';

import TrplForm from '../../common/TrplForm/TrplForm';
import TrplFormFullScreenDialog from '../../common/TrplForm/TrplFormFullScreenDialog';
import TrplsTable from '../../common/TrplsTable/TrplsTable';

import Intent from '../../common/Intent';

import DashboardGroup from './components/DashboardGroup';
import { colPadding } from '../../constants';

import Clear from '@mui/icons-material/Clear';
import Search from '@mui/icons-material/Search';
import { hasPageHorizontalScrollbar, getAllFormConcepts } from '../../utils';

const styles = {
  formTitle: {
    width: 'fit-content',
    //marginBottom: 'calc(1rem - 10px)',
  },
  groupHeading: {
    color: '#414349',
    fontWeight: 600,
    fontSize: 12,
    marginTop: '1px',
    letterSpacing: '0.1px',
    padding: '16px 16px 5px 18px',
    whiteSpace: 'nowrap',
  },
  groupContent: {
    padding: '0 10px 10px 10px',
  },
  dashboardLink: {
    position: 'relative',
    height: 36,
    display: 'flex',
    color: '#4c4c4c',
    padding: '0 8px',
    borderRadius: '6px',
    alignItems: 'center',
    letterSpacing: '0.1px',
    justifyContent: 'space-between',
    '&:hover': {
      background: 'rgb(230 234 243)',
    },
    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      left: 5,
      right: 5,
      height: '0.5px',
      backgroundColor: '#e4e9f3',
    },
    '&:last-child::after': {
      display: 'none',
    },
  },
  dashboardLinkIcon: {
    fontSize: 16,
  },
  intentMesBlock: {
    display: 'inline-flex',
    maxWidth: '800px',
    borderRadius: '6px',
    background: '#FFFF',
    alignItems: 'center',
    marginBottom: '10px',
    width: 'fit-content',
    padding: '10px 10px 10px 10px',
    boxShadow: '0px 1px 2px rgba(0, 0, 2, 0.1)',
    '&:hover': {
      boxShadow: '1px 3px 5px rgba(0, 0, 2, 0.1)',
    },
  },
  dashboardSearchBox: {
    display: 'flex',
    alignItems: 'center',
    margin: '30px 0 20px 10px',
  },
  dashboardSearch: {
    width: '350px',
    height: '34px',
    border: 'none',
    color: '#4C4C4C',
    paddingLeft: '36px',
    outline: '1px solid #eeecf8',
    '&:hover': {
      boxShadow: '0px 0px 0px 4px rgb(201, 198, 228, 0.3)',
    }
  },
  dashboardSearchClear: {
    marginLeft: '-32px',
    color: '#C4C4C4',
    fontSize: '20px',
    cursor: 'pointer',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  dashboardSearchIcon: {
    marginRight: '-30px',
    zIndex: 100,
    flexShrink: '0',
    color: '#C4C4C4',
    fontSize: '20px',
  },
  nothingToShow: {
    margin: '30px 0 0 155px',
    fontSize: '13px',
    color: '#878787',
  },
  ...CommonStyles,
};

class DashboardPage extends ComponentWrapper {
  state = {
    accountDashboards: [],
    accountIntents: [],
    trplFormModalShowPids: [],
    trplFormModalOpened: false,
    trplFormModal: {
      mode: 'create',
      node: {},
      rst: {},
      trpl: {},
    },
    displayDashboardSearch: false,
    hiddenInstructionTooltips: [],
  };

  componentDidMount() {
    document.title="Dashboard | Milkyweb";

    const { updateMetaIntents } = this.props;
    updateMetaIntents();
    this.getDashboard();

    window.addEventListener('resize', this.onResizeWindowEvent);
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeWindowEvent);
  }

  onResizeWindowEvent = () => {
    const { displayDashboardSearch } = this.state;
    if (hasPageHorizontalScrollbar()) {
      if (!displayDashboardSearch) this.setState({ displayDashboardSearch: true });
    } else {
      const dashboardSearch = document.getElementById('dashboardSearch');
      if (dashboardSearch && !dashboardSearch.value) this.setState({ displayDashboardSearch: null });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { displayDashboardSearch } = this.state;
    const { intents } = this.props;

    if (JSON.stringify(this.props.intents) !== JSON.stringify(prevProps.intents)
      || JSON.stringify(this.props.jels) !== JSON.stringify(prevProps.jels))
      this.getIntents(intents);

    if (!displayDashboardSearch && hasPageHorizontalScrollbar())
      this.setState({ displayDashboardSearch: true });
  };

  getDashboard = () => {
    this.get({
      url: `/get_dashboard`,
      cb: (res) => {
        const accountDashboards = res.dashboard || [];

        this.setState({ accountDashboards, isLinksFrmsLoaded: true });
      },
    });
  };

  getIntents = (intents) => {
    const { jels } = this.props;
    let accountIntents = [];
    if (!intents) return;

    intents.forEach(intent => {
      const form = Object.assign({}, Object.values(jels.jelData).find(view => view.id === intent.formId));
      form.iid = intent.iid;
      form.complete = intent.complete;
      form.filter = intent.filter;
      accountIntents.push(form);
    });

    this.setState({ accountIntents });
  };

  openTrplFormFull = (params) => {
    const { concept, form, node, mode, groups, title, formId, tabs, graph_filter_id, graphFilterIdsObj } = params;

    const { trplFormModal } = this.state;

    trplFormModal.node = node;
    trplFormModal.mode = mode;
    trplFormModal.title = title ? title : 'Edit';
    trplFormModal.groups = groups;
    trplFormModal.id = formId;
    trplFormModal.concept = concept;
    trplFormModal.form = form;
    trplFormModal.tabs = tabs;
    trplFormModal.graph_filter_id = graph_filter_id;
    trplFormModal.initialViewId = formId;
    trplFormModal.graphFilterIdsObj = graphFilterIdsObj;

    this.setState(
      {
        trplFormModal,
      },
      () => {
        this.setState({
          trplFormModalOpened: true,
        });
      }
    );
  };

  closeTrplFormModal = () => {
    let { trplFormModal } = this.state;
    const { updateMetaIntents } = this.props;

    this.setState({
      trplFormModal,
      trplFormModalOpened: false,
    });

    trplFormModal = {
      mode: 'create',
      node: {},
      groups: [],
    };

    updateMetaIntents();
  };

  onSearchView = (value) => {
    const { jels } = this.props;
    const { accountDashboards, filteredViews } = this.state;

    if (!value || !value.replaceAll(' ', '')) {
      if (filteredViews) this.setState({ filteredViews: null });
      return;
    }
    value = value.toLowerCase();

    const isNumber = /^[0-9]+$/.test(value);

    const includesNumber = val => ((val || '') + '').includes(value);
    const includesString = val => (val || '').toLowerCase().includes(value);

    const checkView = view => isNumber ? includesNumber(view.id) || includesString(view.title) : includesString(view.title);
    const checkGroup = group => includesString(group.title);
    const checkLinkJel = jel => isNumber ? includesNumber(jel.jel) || includesString(jel.title) : includesString(jel.title);
    const checkLinkUrl = link => includesString(link.title) || includesString(link.url);

    const dashboardIds = [];
    const groupTitleLocations = [];
    const linkLocations = [];

    for (const idxDashboard in accountDashboards) {
      const dashboard = accountDashboards[+idxDashboard];
      if (!dashboard.acc_concept) continue;// if this is old dashboard - don't render it
      let displayDashboard = checkView(dashboard);
      if (displayDashboard) dashboardIds.push(dashboard.id);

      for (const idxView in dashboard.views) {
        const view = dashboard.views[+idxView];
        const frm = jels.jelData[view.value];
        if (!frm) continue;
        let displayView = checkView(frm);
        if (displayView) {
          if (!dashboardIds.includes(frm.id)) dashboardIds.push(frm.id);
          if (!dashboardIds.includes(dashboard.id)) dashboardIds.push(dashboard.id);
        }

        for (const idxRow in frm.groups) {
          const row = frm.groups[+idxRow];
          for (const idxGroup in row) {
            const group = row[+idxGroup];
            const groupLocation = '' + frm.id + idxRow + idxGroup;
            let displayGroup = checkGroup(group);
            if (displayGroup) {
              if (!groupTitleLocations.includes(groupLocation)) groupTitleLocations.push(groupLocation);
              if (!dashboardIds.includes(frm.id)) dashboardIds.push(frm.id);
              if (!dashboardIds.includes(dashboard.id)) dashboardIds.push(dashboard.id);
            }

            if (group.links) {
              for (const idxLink in group.links) {
                const linkLocation = groupLocation + idxLink;
                const link = group.links[+idxLink];
                const jelLink = link.jel && jels.jelData[link.jel];
                if (displayDashboard || displayView || displayGroup
                  || (link.jel && ((link.title && checkLinkJel(link)) || (!link.title && jelLink && checkView(jelLink))))
                  || (link.url && checkLinkUrl(link))) {
                  linkLocations.push(linkLocation);
                  if (!groupTitleLocations.includes(groupLocation)) groupTitleLocations.push(groupLocation);
                  if (!dashboardIds.includes(frm.id)) dashboardIds.push(frm.id);
                  if (!dashboardIds.includes(dashboard.id)) dashboardIds.push(dashboard.id);
                }
              }
            }
          }
        }
      }
    }

    const filteredViewsNew = {
      dashboardIds,
      groupTitleLocations,
      linkLocations
    };

    this.setState({ filteredViews: filteredViewsNew });
  };

  render() {
    const { jels, isAi, classes } = this.props;
    const {
      accountDashboards,
      accountIntents,
      filteredViews,
      trplFormModal,
      trplFormModalOpened,
      trplFormModalShowPids,
      displayDashboardSearch,
    } = this.state;

    const formConceptsByKeys = trplFormModal && trplFormModal.form ? getAllFormConcepts(trplFormModal.form) : null;
    const formConcept = trplFormModal && trplFormModal.form && trplFormModal.form.concept ? trplFormModal.form.concept :
    formConceptsByKeys ? Object.values(formConceptsByKeys)[0] : 0;

    return (
      <div className={classes.p20} style={{ position: 'relative', top: isAi ? '-50px' : '', marginBottom: '100px' }}>

        <TrplFormFullScreenDialog
          isOpen={trplFormModalOpened}
          paperFullScreenStyles={classes.trplFormPaper}
        >
          <div className={classes.pb120}>
            <TrplForm
              title={trplFormModal.title}
              formId={trplFormModal.id}
              mode={trplFormModal.mode}
              show_pids={trplFormModalShowPids}
              updateParentData={this.updateData}
              iId={trplFormModal.node && trplFormModal.node.id}
              closeModal={this.closeTrplFormModal}
              initialViewId={trplFormModal.initialViewId}
              graphFilterIdsObj={trplFormModal.graphFilterIdsObj}
              graph_filter_id={trplFormModal.graph_filter_id}
              formConceptId={formConcept}
              formConceptsByKeys={formConceptsByKeys}
              paperFullScreenStyles={classes.tprlFormPaper}
              groups={trplFormModal.groups}
              tabs={trplFormModal.tabs}
            />
          </div>
        </TrplFormFullScreenDialog>

        <div style={{ display: 'grid', margin: '0 0 10px 20px' }}>
          {accountIntents.map((intent, alertIndex) => {
            return (
              <React.Fragment key={alertIndex}>
                <Intent
                  intent={intent}
                  openTrplFormFull={this.openTrplFormFull}
                />
              </React.Fragment>
            )})
          }
        </div>

        {isAi ? null : displayDashboardSearch && (
          <div className={classes.dashboardSearchBox}>
            <Search
              className={`${classes.dashboardSearchIcon}`}
            />
            <input
              id={'dashboardSearch'}
              //autoFocus
              placeholder={'Search by tables, forms, groups'}
              className={classes.dashboardSearch}
              onChange={(e) => this.onSearchView(e.target.value)}
              style={{
                borderRadius: '20px',
                outline: filteredViews ? '1px solid #EEA878' : '',
                boxShadow: filteredViews ? '0px 0px 0px 4px rgb(250, 230, 216, 1)' : '',
              }}
            />
            {filteredViews && (
              <Clear
                className={classes.dashboardSearchClear}
                onClick={() => {
                  const dashboardSearch = document.getElementById('dashboardSearch');
                  if (dashboardSearch) dashboardSearch.value = '';
                  this.onSearchView();
                }}
              />
            )}
          </div>
        )}

        {accountDashboards.map((dashboard, dashboardIndex) => {
          // if this is old dashboard - don't render it
          if (!dashboard.acc_concept) return null;
          if (filteredViews && !filteredViews.dashboardIds.includes(dashboard.id)) return null;
          return (
            <div key={dashboardIndex}>
              {dashboard.views.map((view, viewIndex) => {
                const frm = jels.jelData[view.value];

                if (frm) {
                  if (filteredViews && !filteredViews.dashboardIds.includes(frm.id)) return null;
                  return (
                    <div key={viewIndex} style={{ marginBottom: '40px' }}>

                      {frm.title &&
                        <div style={{ padding: '20px 20px 10px 20px'}}>
                          <h3 className={classes.formTitle}>{frm.title}</h3>
                        </div>
                      }

                      <div>
                        {frm.groups.map((row, rowIndex) => {
                          let atLeastOneGroupHasWidth = false;
                          let atLeastOneGroupHasHeight = false;

                          row.forEach(group => {
                            if (group.width) atLeastOneGroupHasWidth = true;
                            if (group.height) atLeastOneGroupHasHeight = true;
                          });

                          return (
                            <div
                              key={rowIndex}
                              className={`${classes.flex}`}
                              style={{
                                width: '100%',
                                alignItems: 'stretch',
                                flexWrap: `${atLeastOneGroupHasWidth ? 'wrap' : 'nowrap'}`,
                                margin: '5px',
                              }}
                            >
                              {row.map((group, groupIndex) => {
                                const groupWidth = `${group.width ? `calc(${group.width} - ${colPadding})` : 'calc(100% - 15px)'}`;
                                const groupStyles = {
                                  height: atLeastOneGroupHasHeight ? 'max-content' : '',
                                  flexShrink: `${atLeastOneGroupHasWidth ? 0 : 'auto'}`,
                                  overflow: `${group.type === 'table' ? 'auto' : 'visible'}`,
                                  boxShadow: 'rgb(183 172 212 / 10%) 0px 1px 2px',
                                  outline: '1px solid #ffff',
                                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: "12px",
                                  position: 'relative',
                                };

                                if (group.type === 'table') {
                                  const tbl = jels.jelData[group.tableId];

                                  return (
                                    <div className={classes.mr5} style={{ ...groupStyles, width: groupWidth}} key={groupIndex}>
                                      <span className={classes.groupHeading} style={{ marginBottom: '-2px' }}>{group.title}</span>

                                      <TrplsTable
                                        isEmbed
                                        key={groupIndex}
                                        settings={tbl}
                                        tableGroupIndex={`${viewIndex}-${rowIndex}-${groupIndex}`}
                                      />
                                    </div>
                                  );
                                } else {
                                  if (filteredViews
                                    && !filteredViews.groupTitleLocations.includes('' + frm.id + rowIndex + groupIndex)) {
                                    return null;
                                  } else return (
                                    <div style={{ ...groupStyles, width: groupWidth }} className={classes.mr10} key={groupIndex}>
                                      <DashboardGroup
                                        frmId={frm.id}
                                        group={group}
                                        classes={classes}
                                        rowIndex={rowIndex}
                                        jelData={jels.jelData}
                                        groupIndex={groupIndex}
                                        filteredViews={filteredViews}
                                        openTrplFormFull={this.openTrplFormFull}
                                      />
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                } else return null;
              })}
            </div>
          );
        })}

        {filteredViews && (!filteredViews.dashboardIds.length || !filteredViews.groupTitleLocations.length) && (
          <div className={classes.nothingToShow}>Nothing to show</div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
    jels: state.jels,
    intents: state.meta.intents,
  }), { updateMetaIntents })(withStyles(styles)(DashboardPage));
